<template>
    <b-form
        class="step-form text-center registered-customer-id"
        @submit.stop.prevent="onSubmit"
    >
        <div class="row">
            <div class="col-lg-12">
                <div class="fields-area registration-completed">
                    <div class="row">
                        <div class="col-lg-12">
                            <h3>Thank you</h3>
                            <p>
                                {{ registrationText }}
                            </p>
                            <p v-if="warning">
                                {{ warning }}
                            </p>

                            <!--                            <div class="generated-customer-id">-->
                            <!--                                <h4>{{ idenfoID }}</h4>-->
                            <!--                                <p>UNIQUE CUSTOMER ID</p>-->
                            <!--                            </div>-->
                        </div>
                    </div>
                </div>
                <base-button
                    btn-type="submit"
                    btn-variant="primary"
                    class="btn-min-width"
                    :btn-label="registrationBtnText"
                ></base-button>
            </div>
        </div>
    </b-form>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {}, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            registrationText: null,
            registrationBtnText: null,
            idenfoID: '',
            FirstName: null,
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['form', 'dataSegmentId', 'warning']),

        // dataSegmentId() {
        //     if (this.$route.params.dataSegmentId) {
        //         return this.$route.params.dataSegmentId
        //     }
        //     return this.$store.getters.dataSegmentId
        // },
    }, // End of Component > mounted
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        dataSegmentId(value) {
            if (value) {
                this.onLoad()
            }
        },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        this.onLoad()
        this.idenfoID = this.$store.state.registration.form.idenfoId
        this.$store.commit('initDefaultFields', 'form')
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        /**
         * Handle when the form has been submitted
         *
         * @return {void}
         */
        onSubmit() {
            if (this.$route.meta.publicRegistration === true) {
                this.$router.push({
                    name: 'public-registration-setup-profile',
                    params: {
                        dataSegmentId: this.dataSegmentId,
                    },
                })
            } else {
                this.$router.push('/register-customer/setup-profile')
            }
        }, // End of onSubmit() method

        /**
         * Handle when the page is loaded
         *
         * @return {void}
         */
        onLoad() {
            if (!this.form.idenfoId) {
                return this.onSubmit()
            }
            if (this.$route.meta.publicRegistration === true) {
                this.registrationText =
                    'The account creation request has been initiated and a link has been sent to the customer for ID Verification and form review'
                this.registrationBtnText = 'GO TO MAIN WEBSITE'
            } else {
                this.registrationText =
                    'The account creation request has been initiated and a link has been sent to the customer for ID Verification and form review'
                this.registrationBtnText = 'REGISTER ANOTHER CUSTOMER'
            }
        }, // End of onLoad() method
    }, // End of Component > watch
} // End of export default
</script>
